import type { WordCollection } from "../collection.types";

export const amberHarvestCollection: WordCollection = {
  id: "amber-harvest",
  title: "Amber Harvest",
  icon: "leaf-maple",
  isWordlistViewable: true,
  startDate: new Date(new Date().getFullYear(), 8, 1), // September 1st
  endDate: new Date(new Date().getFullYear(), 8, 30), // September 30th
  words: [
    "abundance",
    "autumn",
    "balance",
    "brilliant",
    "bronze",
    "clear",
    "copper",
    "corn",
    "glow",
    "gold",
    "grain",
    "harmony",
    "harvest",
    "intense",
    "maple",
    "middle",
    "oak",
    "rich",
    "ripe",
    "rust",
    "scale",
    "sharp",
    "symmetry",
    "wheat",
  ],
};
